export default "__VITE_PUBLIC_ASSET__74533e23__"